import { render, staticRenderFns } from "./RowSituacaoCadastro.vue?vue&type=template&id=3a80e446&scoped=true&"
import script from "./RowSituacaoCadastro.vue?vue&type=script&lang=js&"
export * from "./RowSituacaoCadastro.vue?vue&type=script&lang=js&"
import style0 from "./RowSituacaoCadastro.vue?vue&type=style&index=0&id=3a80e446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a80e446",
  null
  
)

export default component.exports